import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable()
export class NoAuthGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService, private router:  Router) {

  }
  canActivate() {
    if (!this.authService.getAuth().isAuthorized()){
        return true;
    } else {
        this.router.navigate(['dashboard']);
        return false;
    }
  }

  canActivateChild() {
    if (!this.authService.getAuth().isAuthorized()){
        return true;
    } else {
        this.router.navigate(['dashboard']);
        return false;
    }
  }

}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/login/noauth-guard.service.ts